import {pick, each} from 'lodash';
import FormModel from '@baidu/ve-ria/views/FormModel';

export default class CardDetailModel extends FormModel {

    /**
     * @override
     */
    title = '';

    /**
     * @override
     */
    crumbData = [
        {
            text: '卡片管理',
            to: '/card/list'
        },
        {
            text: ''
        }
    ];

    /**
     * @override
     */
    formData = {
        impl: {},
        name: '',
        notes: '',
        data: '{}',
        preview: '',
        aderName: '',
        qrCodeUrl: '',
        reviewComments: {
            designReview: [],
            materialReview: []
        }
    };

    /**
     * @override
     */
    init() {
        super.init();

        this.setCrumbData();
        this.id = this.getRouteParams().id;
        this.detailRequester = this.api.cardGet;
    }

    setCrumbData() {
        const path = this.getRoutePath();
        const meta = this.getRouteMeta();
        const type = this.type = path.slice(1).split('/').shift();
        if (meta.isAdmin) {
            this.crumbData[0].text = '物料管理';
        }
        else if (type === 'frame') {
            this.crumbData[0] = {
                text: '中间页管理',
                to: '/frame/list'
            };
        }
    }

    /**
     * @override
     */
    adaptData(data) {
        this.crumbData[1].text = data.name;
        data.reviewComments = this.processReviewComments(data.reviewComments);
        const keys = ['impl', 'data', 'preview', 'qrCodeUrl', 'name', 'aderName', 'notes', 'reviewComments'];
        return pick(
            data,
            keys
        );
    }
    /**
     * @params {object}
     * @return {object}
     */
    processReviewComments(comments) {
        const result = {
            designReview: [],
            materialReview: []
        };
        each(comments, (item, key) => {
            if (key === 'prodReviewComment') {
                if (item.status === 'FAILED') {
                    result.materialReview.push(item.rejectReason);
                }
            }
            else if (item.status === 'FAILED') {
                result.designReview.push(item.rejectReason);
            }
        });
        return result;
    }
}
